@if(isOpen()){
	<ng-content select="app-inline-confirmation-message"/>
	<ng-content select="app-inline-confirmation-operators"/>
}